import React, { useEffect, useState } from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";

import logo from "../assets/images/logo.png";
import { AuthContextValue, useAuth } from "../providers/AuthProvider";
import { Button } from "antd";
import Login from "./modals/Login";
// import { useSignOut } from '../api/auth';

const GuestHeader = () => {
  const location = useLocation();
  const [pathName, setPathName] = useState("/");
  const navigate = useNavigate();
  const { user, logout } = useAuth() as AuthContextValue;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (location) {
      setPathName(location.pathname);
    }
  }, [location]);

  return (
    <section className="w-full px-[29px] md:px-[75px] lg:px-[100px] flex flex-col shadow-md">
      <Login open={open} hideModal={() => setOpen(false)} />
      <div className="flex justify-between items-center pt-[10px]">
        <img src={logo} alt="log" width="112" height="55" />
        <div className="hidden md:block text-5xl font-bold">SHEGAFRE</div>
        <div>
          {!user && location.pathname !== "/login" && (
            <Button
              className="shad-btn shad-primary-btn"
              onClick={() => setOpen(true)}
            >
              Log In
            </Button>
          )}
        </div>
        {user && (
          <div>
            <Button
              className="shad-primary-btn"
              onClick={() => {
                const token = localStorage.getItem("token");
                if (token) {
                  logout();
                }
                localStorage.removeItem("token");
              }}
            >
              Log Out
            </Button>
          </div>
        )}
        {/* {session && session.user && <div><Button className="shad-primary-btn" onClick={() => signOut()}>Logout</Button></div>} */}
      </div>
      <div className="hidden md:flex justify-center mb-2">
        <ul className="flex gap-[70px]">
          <li>
            <Link
              to="/"
              className={
                pathName === "/" ? "border-b-2 border-green-400" : "border-b-0"
              }
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/products"
              className={
                pathName === "/products"
                  ? "border-b-2 border-green-400"
                  : "border-b-0"
              }
            >
              Products
            </Link>
          </li>
          <li>
            <Link
              to="/farmers"
              className={
                pathName === "/farmers"
                  ? "border-b-2 border-green-400"
                  : "border-b-0"
              }
            >
              Farmers
            </Link>
          </li>
          <li>
            <Link
              to="/locations"
              className={
                pathName === "/locations"
                  ? "border-b-2 border-green-400"
                  : "border-b-0"
              }
            >
              Locations
            </Link>
          </li>
          <li>
            <Link
              to="/blog"
              className={
                pathName === "/blog"
                  ? "border-b-2 border-green-400"
                  : "border-b-0"
              }
            >
              Blog
            </Link>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default GuestHeader;
